export const getPageTitle = (primaryLabel: string, secondaryLabel?: string) => {
  let title = `Quill.org | ${primaryLabel}`
  if(secondaryLabel) {
    title += ` | ${secondaryLabel}`
  }
  return title
}
